// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "dist/js/" + chunkId + "." + {"1516":"6aba4077","3810":"7b002590","6622":"b502ab0b","8167":"0b8e333f"}[chunkId] + ".js";
};